import React, { Component } from 'react';

class Statistics extends Component {
    render() {
        return (
            <div>
                <h1 className="display-2 mb-5 mt-5">
                    Estadisticas
                </h1>
            </div>
        );
    }
}

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/views/Statistics.js